import React, { useState, useEffect } from "react";
import Footerstyles from "./FooterNew.module.css";
import { Link, NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import Contactform from "./Contactform";
import { getfootercontact } from "../../../Services/APIrequests";
import { Modal } from "antd";

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contacts, setContacts] = useState([]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await getfootercontact();
        if (response?.data?.success && response.data.contacts?.length > 0) {
          setContacts(response.data.contacts);
        }
      } catch (error) {
        console.error("Error fetching contact info:", error);
      }
    };

    fetchContacts();
  }, []);

  return (
    <div className={Footerstyles.footerWrapper}>
      <div className={Footerstyles.footerContainer}>
        {/* Hero CTA Section */}
        <div className={Footerstyles.heroCTA}>
          <h1 className={Footerstyles.heroTitle}>Take Charge of Your <span style={{ color: 'var(--AccentColor)' }}>Compliance Today</span></h1>
          <p className={Footerstyles.heroSubtitle}>
            Join thousands of businesses that trust Kohere for hassle-free compliance management.
          </p>
          <button
            type="button"
            className={Footerstyles.getStartedBtn}
            onClick={toggleModal}
          >
            Get Started
          </button>
        </div>
      </div>

      <hr className={Footerstyles.divider} />

      <div className={Footerstyles.footerContainer}>
        {/* Main Footer Content */}
        <div className={Footerstyles.footerGrid}>
          {/* Brand & Left Info */}
          <div className={Footerstyles.footerColumn}>
            <div className={Footerstyles.brandLogo}>
              KOHERE CONNECT PRIVATE LIMITED
            </div>
            <p className={Footerstyles.brandDesc}>
              Customize your requirement with our one to one meeting.
            </p>
            <button
              type="button"
              className={Footerstyles.contactUsBtn}
              onClick={toggleModal}
            >
              Contact us
            </button>

            <div className={Footerstyles.legalSection}>
              <h5 className={Footerstyles.legalTitle}>Legal</h5>
              <ul className={Footerstyles.legalLinks}>
                <li><Link to="/Privacypolicy">Privacy Policy</Link></li>
                <li><Link to="/Terms_Conditions">Terms and Conditions</Link></li>
                <li><Link to="/refundPolicy">Refund Policy</Link></li>
                <li><Link to="/cancellationPolicy">Cancellation Policy</Link></li>
              </ul>
            </div>
          </div>

          {/* Contact Us Column (Phone) */}
          <div className={Footerstyles.footerColumn}>
            <h5 className={Footerstyles.columnTitle}>Contact Us</h5>
            <div className={Footerstyles.contactData}>
              {/* <p className={Footerstyles.contactSubTitle}>Phone :</p> */}
              {contacts.length > 0 &&
                contacts[0].mobileNumber.map((number, index) => (
                  <p key={index} className={Footerstyles.contactItem}>{number}</p>
                ))}
            </div>
          </div>

          {/* Email Column */}
          <div className={Footerstyles.footerColumn}>
            <h5 className={Footerstyles.columnTitle}>Email :</h5>
            <div className={Footerstyles.contactData}>
              {contacts.length > 0 &&
                contacts[0].email.map((email, index) => (
                  <p key={index} className={Footerstyles.contactItem}>{email}</p>
                ))}
            </div>
          </div>

          {/* Resources Column */}
          <div className={Footerstyles.footerColumn}>
            <h5 className={Footerstyles.columnTitle}>Resources</h5>
            <ul className={Footerstyles.columnLinks}>
              <li><NavLink to="/about">About Us</NavLink></li>
              <li><NavLink to="/blog">Blog</NavLink></li>
              <li><HashLink smooth to="/#Testimonials">Testimonials</HashLink></li>
              <li><HashLink smooth to="/#faqs">FAQs</HashLink></li>
              <li><NavLink to="/contactus">Contact Us</NavLink></li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className={Footerstyles.copyright}>
          © 2026 KOHere. All rights reserved.
        </div>
      </div>

      <Modal
        open={isModalOpen}
        onCancel={toggleModal}
        footer={null}
        destroyOnClose
        centered
        width={700}
      >
        <Contactform closeModal={toggleModal} />
      </Modal>
    </div>
  );
};

export default Footer;


